
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface ModalForceFinishProps {
  isOpen: boolean;
  onClose: () => void;
  onFinalize: () => void;
  countdown?: number;
}

function ModalForceFinish({ isOpen, onClose, onFinalize, countdown = 60 }: ModalForceFinishProps) {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState(countdown);

  useEffect(() => {
    if (!isOpen) {
      setTimeLeft(countdown);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          // Auto-finalize when countdown reaches 0
          onFinalize();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isOpen, countdown, onFinalize]);

  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-[500px] w-full">
        <DialogHeader>
          <DialogTitle>{t('finalize')}</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <p className="mt-2">{t('finalize_text')}</p>
          <p className="mt-4 text-sm text-muted-foreground">
            {t('auto_finalize_in', { seconds: timeLeft })} {timeLeft}s
          </p>
        </div>
        <DialogFooter>
          <Button 
            variant="secondary" 
            onClick={onClose} 
            className="bg-gray-200 hover:bg-gray-300 text-black"
          >
            {t('yes_continue')}
          </Button>
          <Button 
            onClick={onFinalize} 
            className="bg-[#257272] hover:bg-[#257272] text-white"
          >
            {t('no_finalize')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ModalForceFinish;
